// @flow

import { sendMessageWithCommsAndAlert } from "./async";

import type { Dispatch } from "redux";

export const SET_AUTHENTICATION_TOKEN_PARAM_PRESENT = "SET_AUTHENTICATION_TOKEN_PARAM_PRESENT";
export const SET_DEPOSIT_AMOUNT = "SET_DEPOSIT_AMOUNT";
export const SET_DEPOSIT_CONFIRMED = "SET_DEPOSIT_CONFIRMED";
export const SET_DEPOSIT_PAYMENT_METHOD = "SET_DEPOSIT_PAYMENT_METHOD";
export const SET_DEPOSIT_CREDIT_CARD = "SET_DEPOSIT_CREDIT_CARD";

export function setAuthenticationTokenParamPresent(value: boolean) {
  return { type: SET_AUTHENTICATION_TOKEN_PARAM_PRESENT, value };
}

export function setDepositAmount(amount: number) {
  return { type: SET_DEPOSIT_AMOUNT, amount };
}

export function setDepositConfirmed() {
  return { type: SET_DEPOSIT_CONFIRMED };
}

export function setDepositCreditCard(field: string, value: string | boolean) {
  return {
    type: SET_DEPOSIT_CREDIT_CARD,
    field,
    value
  };
}

export function setDepositPaymentMethod(paymentMethod: string) {
  return { type: SET_DEPOSIT_PAYMENT_METHOD, paymentMethod };
}

export function depositAch(userId: number, amount: number, routingNumber: string, accountNumber: string, history: {}) {
  return (dispatch: Dispatch) => {
    sendMessageWithCommsAndAlert(dispatch, "session:" + userId, "ach_deposit", {
      amount: amount,
      "routing_number": routingNumber,
      "account_number": accountNumber
    }).then(({ deposit: deposit }) => {
      dispatch(setDepositConfirmed());
      if (deposit === "screened") {
        history.push("/deposit/screened");
      } else {
        history.push("/deposit/confirmation");
      }
    });
  };
}

export function depositNewCreditCard(userId: number, firstName: string, lastName: string, cardNumber: string, expMonth: string, expYear: string, cvv: string, amount: number, rememberCard: boolean, history: {}) {
  return depositCreditCard(userId, {
    "first_name": firstName,
    "last_name": lastName,
    "card_number": cardNumber,
    "exp_month": expMonth,
    "exp_year": expYear,
    cvv: cvv,
    amount: amount,
    "remember_card": rememberCard
  }, history);
}

export function depositSavedCreditCard(userId: number, creditCardId: string, amount: number, history: {}) {
  return depositCreditCard(userId, {
    "credit_card_id": creditCardId,
    amount: amount
  }, history);
}

function depositCreditCard(userId, fields, history: {}) {
  return (dispatch: Dispatch) => {
    sendMessageWithCommsAndAlert(dispatch, "session:" + userId, "credit_card_deposit", fields).then(() => {
      dispatch(setDepositConfirmed());
      history.push("/deposit/confirmation");
    });
  };
}

export function deleteCreditCard(userId: number, creditCardId: string) {
  return (dispatch: Dispatch) => {
    sendMessageWithCommsAndAlert(dispatch, "session:" + userId, "credit_card_delete", {
      "credit_card_id": creditCardId
    });
  };
}
